import nBossConnection from 'modules/base/service/nBossConnection';
import EdaDto from '../dto/EdaDto';

class EdaService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'edaControl';
	}

	/**
	 * @param {number} id
	 * @return {Promise<EdaDto>}
	 */
	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => (response.data !== null ? resolve(new EdaDto().setup(response.data)) : null))
				.catch(reject);
		});
	}
}

export default new EdaService();
